import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { Observable } from 'rxjs';
import { HoneyHazeCardData } from '../../../../../../../models/print-cards/honey-haze-card';
import { PrimaryCannabinoid } from 'src/app/models/enum/shared/cannabinoid';
import { SortUtils } from 'src/app/utils/sort-utils';
import { CannabinoidOrTerpeneFromPool, PropertyPoolSorter } from '../../shared/card-data-with-property-pooling';

@Injectable()
export class HoneyHazeBusinessCardStackContentViewModel extends PrintCardContentViewModel {
  public readonly cardData$: Observable<HoneyHazeCardData>;

  protected pinnedMap = new Map<string, number>([
    [PrimaryCannabinoid.THC, 0],
    [PrimaryCannabinoid.CBD, 1]
  ]);

  protected finalSortLambdaForCompoundProperties = (): PropertyPoolSorter => {
    return (a: CannabinoidOrTerpeneFromPool, b: CannabinoidOrTerpeneFromPool): number => {
      return SortUtils.pinned(this.pinnedMap, a?.title, b?.title);
    };
  };
}
